import React, { PureComponent } from 'react';
import Autosuggest from 'react-autosuggest';

import MenuItem from '@material-ui/core/MenuItem';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';

/* eslint no-eval: 0 */

function renderInputComponent(inputProps) {
    const { inputRef = () => {}, ref, ...other } = inputProps;

    return (
        <TextField
            fullWidth
            InputProps={{
                inputRef: node => {
                    ref(node);
                    inputRef(node);
                }
            }}
            {...other}
        />
    );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion, query);
    const parts = parse(suggestion, matches);

    return (
        <MenuItem selected={isHighlighted} component="div">
            <div>
                {parts.map((part, index) => {
                    return part.highlight ? (
                        <span key={String(index)} style={{ fontWeight: 600 }}>
                            {part.text}
                        </span>
                    ) : (
                        <strong key={String(index)} style={{ fontWeight: 300 }}>
                            {part.text}
                        </strong>
                    );
                })}
            </div>
        </MenuItem>
    );
}

function getSuggestions(data, value, filters) {
    const inputValue = value.trim().toLowerCase()
        , inputLength = inputValue.length
        , max = 5;

    let count = 0;

    if(inputLength === 0){
        return [];
    }else{
        const suggestions = data.filter(suggestion => {
            const keep = count < max && filters(suggestion, inputValue);

            if (keep) {
                count += 1;
                return keep;
            }

            return keep;
        });

        return suggestions;
    }
}

class AutoSug extends PureComponent {
    /* START Constructor */

    constructor(props) {
        super(props);

        this.state = {
            suggestions: []
        }
    }

    /* END Constructor */

    /* START Handlers */

    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(this.props.data, value, this.props.filter),
        });
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    /* END Handlers */

    /* START Renders */

    render() {
        const { inputProps, sug, sugInputValue, sugValue } = this.props;

        const autosuggestProps = {
            suggestions: this.state.suggestions,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
            getSuggestionValue: (suggestion) => {sugValue(suggestion); return eval(sugInputValue)},
            renderInputComponent,
            renderSuggestion: (suggestion, { query, isHighlighted }) => renderSuggestion(eval(sug), { query, isHighlighted }),
        }
        
        return (
            <Autosuggest
                {...autosuggestProps}
                inputProps={inputProps}
                renderSuggestionsContainer={options => (
                    <Paper {...options.containerProps} square>
                        {options.children}
                    </Paper>
                )}
            />
        );
    }
}

export default AutoSug;
